export const GET_APP_VERSIONS_PENDING = '[APP_VERSIONS_PENDING][GET] get app versions pending';
export const GET_APP_VERSIONS_SUCCESS = '[APP_VERSIONS_SUCCESS][GET] get app versions success';
export const GET_APP_VERSIONS_FAILURE = '[APP_VERSIONS_FAILURE][GET] get app versions failure';
export const APP_UPDATE_RESET_DATA = '[APP_UPDATE][RESET_DATA] app update reset data';



// WEBPACK FOOTER //
// ./src/ui/features/AppUpdate/state/AppUpdateTypes.js